/**
 * Generate a random number between min and max
 * @param min Inclusive
 * @param max Exclusive by default
 * @param maxInclusive Default false
 */
export function getRandomInt(min, max, maxInclusive) {
    if (maxInclusive === void 0) { maxInclusive = false; }
    min = Math.ceil(min);
    max = Math.floor(max);
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    var maxI = maxInclusive ? 1 : 0;
    return Math.floor(Math.random() * (max - (min + maxI))) + min;
}
